import { render, staticRenderFns } from "./ownerCode.vue?vue&type=template&id=226ff6dc&scoped=true"
import script from "./ownerCode.vue?vue&type=script&lang=js"
export * from "./ownerCode.vue?vue&type=script&lang=js"
import style0 from "./ownerCode.vue?vue&type=style&index=0&id=226ff6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226ff6dc",
  null
  
)

export default component.exports